
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "ROI et Instagram Ads : comment optimiser vos résultats ?",
    description:
      "Mesurez et optimisez le ROI de vos campagnes Instagram Ads grâce aux conseils d’ALEO. Découvrez les métriques clés, outils d’analyse et stratégies gagnantes.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
